namespace RedBullMOBILE360.Sms {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Sms.SubscriptionCodesGrid')
    export class SubscriptionCodesGrid extends Serenity.EntityGrid<SubscriptionCodesRow, any> {
        protected getColumnsKey() { return SubscriptionCodesColumns.columnsKey; }
        protected getDialogType() { return SubscriptionCodesDialog; }
        protected getIdProperty() { return SubscriptionCodesRow.idProperty; }
        protected getInsertPermission() { return SubscriptionCodesRow.insertPermission; }
        protected getLocalTextPrefix() { return SubscriptionCodesRow.localTextPrefix; }
        protected getService() { return SubscriptionCodesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }
    }
}